// extracted by mini-css-extract-plugin
export default {"container":"ResetPassword_container__udzWV","content":"ResetPassword_content__Cb2fM","form":"ResetPassword_form__bjlGb","btn":"ResetPassword_btn__fqL2F"};